
const icon = {
    MARKER_PLUS (number) {
        return `data:image/svg+xml;charset=utf-8, <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52"><defs><style>.a{fill:rgb(199, 203, 209);opacity:0.5;}.b{fill:rgb(35, 95, 155);}.c{fill:none;}.d{fill:rgb(255, 255, 255);font-size:18px;font-family:Roboto-Medium, Roboto;font-weight:500;letter-spacing:0.015em;}</style></defs><g transform="translate(1785 -2571)"><g transform="translate(-27 211)"><ellipse class="a" cx="12.5" cy="4" rx="12.5" ry="4" transform="translate(-1744 2402)"/><path class="b" d="M-675.436,742.954a15.2,15.2,0,0,1,15.522-14.871,15.2,15.2,0,0,1,14.87,14.871c0,11.381-15.2,28.183-15.2,28.183S-675.436,754.335-675.436,742.954Z" transform="translate(-1071.564 1634.921)"/></g><g transform="translate(-1785 2571)"><path class="c" d="M0,0H52V52H0Z"/></g><text class="d" transform="translate(-1764 2595)"><tspan x="0" y="0">${number}</tspan></text></g></svg>`
    },
}
function iconsvgcluster (number) {
    const result = icon.MARKER_PLUS
    if (result) {
        return result(number)
    }
}
exports.iconsvgcluster = iconsvgcluster
